module.exports = __webpack_public_path__ + "media/images/dummy-content/user-4-40ccb60a8dbe944bac55469c95276e26.jpg";